import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate, NavLink, Link } from "react-router-dom";
import { Header } from "./components/Header";
import { ShimmerTable } from "react-shimmer-effects";
import toast, { Toaster } from "react-hot-toast";
import { type } from "@testing-library/user-event/dist/type";

const API_URL = "/api";

export default function TermSheet() {
  const { id } = useParams();
  console.log("🔎 Route id:", id);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [company, setCompany] = useState(null);
  const [transactionData, setTransactionData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checklistFormData, setChecklistFormData] = useState([]);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/getTransactionDetails/${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("📥 Full API Response:", data);
        setTransactionData(data);
        console.log("transactionData:", transactionData);
        // setFormData(data?.DocumentCheckList || {});
        setFormData(data); // keep full object for Loan Info
        setCompany(data);
        console.log("Data:", data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyDetails();
  }, []);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setFormData(transactionData);
    setChecklistFormData(transactionData?.DocumentCheckList || []);
    setIsEditing(false);
  };

  const renderStatusCell = (section) => {
    let value = formData?.[section]?.STATUS || "";
    if (section === "ENTEREXPIRYDATE") value = "";
    return isEditing ? (
      <select
        className="form-select"
        value={value}
        onChange={(e) => handleChange(e, section, "STATUS")}
      >
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
        <option value="N/A">N/A</option>
      </select>
    ) : (
      <div
        style={{
          backgroundColor: value === "Yes" ? "#58a65c" : "#fdf3d0",
          color: value === "Yes" ? "#fff" : "#000",
          textAlign: "center",
        }}
      >
        {value || ""}
      </div>
    );
  };

  const criteriaLabels = {
    COMPANYNAMEISCORRECT: "Company name is correct",
    THEREGISTRATIONISCURRENT: "The registration is current",
    THERETURNCOVERSTHEMOSTRECENTPERIOD:
      "The return covers the most recent period",
    SHAREHOLDER_SMATCHORGANIZATIONCHART_IFPROVIDED:
      "Shareholder(s) match organization chart (if provided)",
    THECHARTISSIGNEDANDDATED: "The chart is signed and dated",
    STATEMENTSARESIGNEDBYAUDITOR: "Statements are signed by auditor",
  };

  const renderCheckCell = (section) => {
    // if (section === "SUBMITTEDBUSINESSREGISTRATION") return "";

    // Show the label for these fields instead of CHECKINGDETAILS
    if (
      section === "COMPANYNAMEISCORRECT" ||
      section === "THEREGISTRATIONISCURRENT" ||
      section === "THERETURNCOVERSTHEMOSTRECENTPERIOD" ||
      section === "SHAREHOLDER_SMATCHORGANIZATIONCHART_IFPROVIDED" ||
      section === "THECHARTISSIGNEDANDDATED" ||
      section === "STATEMENTSARESIGNEDBYAUDITOR"
    ) {
      return criteriaLabels[section] || "";
    }

    if (section === "ENTEREXPIRYDATE") {
      const rawDate = formData?.ENTEREXPIRYDATE?.CHECKINGDETAILS;
      return rawDate ? formatDate(rawDate) : "";
    }

    return formData?.[section]?.CHECKINGDETAILS || "";
  };

  const handleInputChange = (sectionKey, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [field]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const { _id, ...rest } = formData;
    if (!_id) {
      alert("Missing _id");
      return;
    }
    // Remove any fields with undefined values
    const cleanedData = {};
    for (const key in rest) {
      if (rest[key] !== undefined) {
        cleanedData[key] = rest[key];
      }
    }
    const updatePayload = {
      _id: _id, // Make sure it's a string
      update_data: cleanedData,
    };

    try {
      const response = await fetch(
        "http://localhost:8000/riverchain/techop/v1.1/updateCompanyLog",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        }
      );

      const resultText = await response.text();

      if (!response.ok) {
        console.error("❌ Update failed:", resultText);
        alert("Update failed:\n" + resultText);
      } else {
        toast.success("Company log updated successfully");
      }
    } catch (error) {
      console.error("🚨 Network error:", error);
      toast.danger("An error occurred while updating the profile.");
    } finally {
      setIsSubmitting(false);
    }
  };
  // Utility: format date values into DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // fallback if invalid date
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };
  const scoreMapping = {
    "Borrower: A": 20,
    "Borrower: B": 15,
    "Borrower: C": 0,
    "Borrower: D": -10,
  };
  const scoreMappingTransaction = {
    "0% to 10%": 0,
    "11% to 20%": 5,
    "21% to 30%": 8,
    "> 30%": 10,
  };
  const today = new Date();
  const formatted = today.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long", // 👈 gives full month name
    year: "numeric",
  });
  // const loanAmount = Number(transactionData?.LOANAMOUNT_HK) || 0;
  // const totalFees = Number(transactionData?.TOTALFEES_HK) || 0;

  // const totalLoanPayment =
  //   transactionData?.LOANAMOUNT_HK != null && transactionData?.TOTALFEES_HK != null
  //     ? loanAmount + totalFees
  //     : null;

  // const totalPayment =
  //   totalLoanPayment !== null
  //     ? totalLoanPayment + totalFees
  //     : null;
  // Build repayment rows first
  const repayments = [
    {
      month: 1,
      principal: Number(transactionData?.LOANAMOUNT_HK || 0),
      interest: Number(transactionData?.TOTALFEES_HK || 0),
      fees: Number(transactionData?.TOTALFEES_HK || 0),
    },
    // Add more rows for each month...
  ];

  // For each row, compute loanPayment + total
  const enrichedRepayments = repayments.map((row) => {
    const loanPayment = row.principal + row.interest; // example formula
    const total = loanPayment + row.fees;

    return { ...row, loanPayment, total };
  });

  // Now safely calculate sums
  const totalPrincipal = enrichedRepayments.reduce(
    (acc, r) => acc + r.principal,
    0
  );
  const totalInterest = enrichedRepayments.reduce(
    (acc, r) => acc + r.interest,
    0
  );
  const totalLoanPayment = enrichedRepayments.reduce(
    (acc, r) => acc + r.loanPayment,
    0
  );
  const totalFees = enrichedRepayments.reduce((acc, r) => acc + r.fees, 0);
  const totalPayments = enrichedRepayments.reduce((acc, r) => acc + r.total, 0);

  return (
    <div className="app-container">
      <Toaster />
      <div className="container-fluid">
        <main className="content">
          <Header />
        </main>
      </div>

      <div className="container">
        <div className="row mt-4">
          <div className="col-md-12">
            <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
              Back to Transaction List
            </NavLink>

            <br />
            <br />
            <NavLink
              to={`/ViewTransactionList/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Loan Details
            </NavLink>

            <NavLink
              to={`/Drawdowns/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Drawdowns
            </NavLink>

            <NavLink
              to={`/ApplicationChecklist/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Application Checklist
            </NavLink>

            <NavLink
              to={`/ScoreCard/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scorecard
            </NavLink>

            <NavLink
              to={`/TransactionSummary/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Transaction Summary
            </NavLink>

            <NavLink to={`/TermSheet/${id}`} className="btn btn-dark ms-2">
              Term Sheet
            </NavLink>

            <NavLink
              to={`/Payments/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Payments
            </NavLink>
            <NavLink
              to={`/RepaymentAndInterest/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Repayment & Interest(Term)
            </NavLink>

            <NavLink
              to={`/ScoringCriteriaTf/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scoring Criteria
            </NavLink>

            <NavLink
              to={`/ScoringGuide/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scoring Guide
            </NavLink>

            <NavLink
              to={`/InterestCalculations/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Interest Calculations
            </NavLink>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ marginTop: "15px" }}>Indicative Loan Proposal</h3>
              <div>
                {isEditing && (
                  <button
                    className="btn btn-secondary me-2 btn-sm"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                )}
                <button
                  className="btn btn-primary btn-sm"
                  onClick={async () => {
                    if (isEditing) {
                      setIsSubmitting(true);
                      await handleSubmit();
                      setIsSubmitting(false);
                    } else {
                      setFormData(transactionData);
                      setIsEditing(true);
                    }
                  }}
                  disabled={isSubmitting}
                >
                  {isEditing
                    ? isSubmitting
                      ? "Submitting..."
                      : "Submit"
                    : "Edit"}
                </button>
              </div>
            </div>

            {loading || !transactionData ? (
              <ShimmerTable row={5} col={5} />
            ) : (
              <>
                <div className="col-md-12">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td>{transactionData?.BORROWER_LABEL || "To"}</td>
                        <td>{transactionData?.BORROWER || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>{transactionData?.DATE_LABEL || "Date"}</td>
                        <td style={{ color: "red" }}>{formatted}</td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.TRANSACTIONID_LABEL ||
                            "Riverchain ID"}
                        </td>
                        <td>{transactionData?.TRANSACTIONID || "N/A"}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    Riverchain is pleased to support the Borrower as its supply
                    chain financing partner with the following proposal for
                    reliable and fast access to working capital through
                    Riverchain.
                  </p>
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.LENDER_LABEL || "Lender"}
                        </td>
                        <td>{transactionData?.LENDER || "N/A"}</td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.BORROWER_LABEL || "Borrower"}
                        </td>
                        <td>{transactionData?.BORROWER || "N/A"}</td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.TERM_SHEET?.LOAN_LABEL || "Loan"}
                        </td>
                        <td>{transactionData?.TERM_SHEET?.LOAN || "N/A"}</td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.TERM_SHEET?.FACILITYAMOUNT_LABEL ||
                            "Facility Amount"}
                        </td>
                        <td>
                          {transactionData?.TERM_SHEET?.FACILITYAMOUNT || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.TERM_SHEET?.USEOFPROCEEDS_LABEL ||
                            "Use of Proceeds"}
                        </td>
                        <td>
                          {transactionData?.TERM_SHEET?.USEOFPROCEEDS || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.TERM_SHEET?.INTERESTRATE_LABEL ||
                            "Interest Rate"}
                        </td>
                        <td>
                          {transactionData?.TERM_SHEET?.INTERESTRATE || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.TERM_SHEET
                            ?.ADMINISTRATIONFEE_LABEL || "Administration fee"}
                        </td>
                        <td>
                          {transactionData?.TERM_SHEET?.ADMINISTRATIONFEE ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.TERM_SHEET?.OVERDUECHARGE_LABEL ||
                            "Overdue charge"}
                        </td>
                        <td>
                          {transactionData?.TERM_SHEET?.OVERDUECHARGE || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.TERM_SHEET?.MATURITYDATE_LABEL ||
                            "Maturity Date"}
                        </td>
                        <td>
                          {transactionData?.TERM_SHEET?.MATURITYDATE || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          {transactionData?.TERM_SHEET?.REPAYMENT_LABEL ||
                            "Repayment"}
                        </td>
                        <td>
                          {transactionData?.TERM_SHEET?.REPAYMENT || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        ></td>
                        <td>
                          <table border="1" cellspacing="0" cellpadding="6">
                            <thead>
                              <tr>
                                <th colspan="6" style={{ textAlign: "center" }}>
                                  Repayment Schedule
                                </th>
                              </tr>
                              <tr style={{ borderBlock: "2px solid black" }}>
                                <th>Month</th>
                                <th>Principal Repayment</th>
                                <th>Interest Payment</th>
                                <th>Total Loan Payment</th>
                                <th>Fees</th>
                                <th>Total Payments</th>
                              </tr>
                            </thead>
                            <tbody>
                              {enrichedRepayments.map((row, i) => (
                                <tr key={i}>
                                  <td>{row.month}</td>
                                  <td>{row.principal.toFixed(2)}</td>
                                  <td>{row.interest.toFixed(2)}</td>
                                  <td>{row.loanPayment.toFixed(2)}</td>
                                  <td>{row.fees.toFixed(2)}</td>
                                  <td>{row.total.toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>

                            <tfoot>
                              <tr
                                style={{
                                  fontWeight: "bold",
                                  background: "#f0f0f0",
                                }}
                              >
                                <td>Total</td>
                                <td>{totalPrincipal.toFixed(2)}</td>
                                <td>{totalInterest.toFixed(2)}</td>
                                <td>{totalLoanPayment.toFixed(2)}</td>
                                <td>{totalFees.toFixed(2)}</td>
                                <td>{totalPayments.toFixed(2)}</td>
                              </tr>
                            </tfoot>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          Application of Proceeds
                        </td>
                        <td>
                          Main Contractor Payments paid to the Lender shall be
                          applied in the following order of priority:
                          <ol>
                            <li>
                              firstly, to any Administration Fee, fees or other
                              charges outstanding;
                            </li>
                            <li>
                              secondly, any Interest and overdue Interest
                              outstanding of each Loan, applied pro rata on each
                              Loan;
                            </li>
                            <li>
                              thirdly, to repay pro rata the outstanding
                              principal amount of each Loan; and
                            </li>
                            <li>
                              fourthly, provided all amounts in i) to iii) have
                              been repaid in full, the balance to the Borrower.
                            </li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          Voluntary Prepayment
                        </td>
                        <td>
                          Prepayments are allowed on repayment dates with 5
                          Business Days prior irrevocable written notice and
                          with Prepayment fee; Prepayments will be applied to
                          the latest scheduled repayment per the Repayment
                          schedule.{" "}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          Prepayment fee
                        </td>
                        <td>[0.50]% on the prepayment amount / [nil]</td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          Projects:
                        </td>
                        <td>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "200px 1fr",
                              rowGap: "6px",
                            }}
                          >
                            <span>
                              {transactionData?.EMPLOYER_LABEL || "EMPLOYER"}
                            </span>
                            <span>{transactionData?.EMPLOYER || "N/A"}</span>

                            <span>
                              {transactionData?.MAINCONTRACTOR_LABEL ||
                                "MAIN CONTRACTOR"}
                            </span>
                            <span>
                              {transactionData?.MAINCONTRACTOR || "N/A"}
                            </span>

                            <span>
                              {transactionData?.PROJECT_LABEL || "PROJECT"}
                            </span>
                            <span>{transactionData?.PROJECT || "N/A"}</span>

                            <span>
                              {transactionData?.INVOICENO_LABEL || "INVOICENO"}
                            </span>
                            <span>{transactionData?.INVOICENO || "N/A"}</span>

                            <span>
                              {transactionData?.INVOICEDATE_LABEL ||
                                "INVOICE DATE"}
                            </span>
                            <span>
                              {transactionData?.INVOICEDATE
                                ? new Date(
                                    transactionData.INVOICEDATE
                                  ).toLocaleDateString("en-GB") // "04/10/2024"
                                : "N/A"}
                            </span>

                            <span>
                              {transactionData?.INVOICEVALUE_HK_LABEL ||
                                "INVOICE VALUE(HK$)"}
                            </span>
                            <span>
                              {transactionData?.INVOICEVALUE_HK || "N/A"}
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          Security
                        </td>
                        <td>
                          All receivables from the Projects to be assigned by
                          way of security to the Lender.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          Collection Agent
                        </td>
                        <td style={{ paddingLeft: "40px" }}>
                          <li>
                            River Square Company Limited appointed as Collection
                            Agent
                          </li>
                          <li>
                            Borrower undertakes to route the financed proceeds
                            from the Projects to the Collection Agent’s
                            nominated Collection Account
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          Conditions Precedent
                        </td>
                        <td style={{ paddingLeft: "40px" }}>
                          <li>
                            Copies of:
                            <ul>
                              {" "}
                              [duly signed Notice of Bank Account Change
                              delivered to the Main Contractor]
                            </ul>
                            <ul>
                              duly signed [payment application][payment
                              certificate][valuation issued by ◦ in respect of
                              [•] of [the Project]
                            </ul>
                          </li>
                          <li>
                            Conditions precedent customary for a loan of this
                            nature.
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ backgroundColor: "#004d40", color: "#fff" }}
                        >
                          Other terms
                        </td>
                        <td style={{ paddingLeft: "40px" }}>
                          <li>
                            Borrower to provide Lender with copies of:
                            <ol>
                              {" "}
                              invoices or payment schedules to suppliers of the
                              Projects
                            </ol>
                            <ol>
                              {" "}
                              evidence satisfactory to the Lender of proper
                              performance by the Borrower on the Projects
                            </ol>
                            <ol>
                              promptly, upon receipt from the Main Contractor,
                              any notices relating to payments (including any
                              payment application, invoice or payment
                              certificate) or any actual payment (whether in the
                              form of cheque or by bank transfer)
                            </ol>
                            <ol>
                              on the last each month, the Borrower’s bank
                              account statements for each of its bank accounts
                              for the prior month
                            </ol>
                            <ol>
                              within 15 days after the end of each financial
                              quarter year, management accounts for that
                              financial quarter
                            </ol>
                          </li>
                          <li>
                            Registration of security at Companies Registry
                          </li>
                          <li>
                            {" "}
                            Standard loan conditions, representations,
                            warranties and undertakings to be included in final
                            documentation.
                          </li>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    The terms and conditions outlined in this indicative
                    proposal are for discussion purpose only, and are subject to
                    the internal approval of the Riverchain, satisfactory
                    documentation and due diligence. This proposal supersedes
                    and replaces all prior proposals sent by Riverchain.{" "}
                  </p>
                  <p>
                    The indicative proposal outlined above does not constitute a
                    binding offer or commitment on the part of the Riverchain or
                    its willingness to enter into the transaction described
                    herein or any other transaction of a similar nature.
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
